import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const oidcConfig = {
	authority: process.env.REACT_APP_OIDC_AUTHORITY,
	client_id: process.env.REACT_APP_OIDC_CLIENT_ID,
	redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI,
	response_type: "code",
	onSigninCallback: () => {
		window.history.replaceState({}, document.title, window.location.pathname);
	},
	metadata: {
		authorization_endpoint: process.env.REACT_APP_OIDC_AUTHORIZATION_ENDPOINT,
		token_endpoint: process.env.REACT_APP_OIDC_TOKEN_ENDPOINT,
	},
	scope: "openid email",
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<AuthProvider {...oidcConfig}>
			<App />
		</AuthProvider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
